import { RolodexEntryType } from 'types'
import { z } from 'zod'

export const SystemDocumentPageJSONSchema = z.looseObject({
  id: z.string().optional(),
  document_id: z.string().optional(),
  page_id: z.string().optional(),
  pipeline_config_hash: z.string().optional(),
  page_num: z.coerce.number().optional(),
  page_classification: z.string().optional().nullable(),
  page_classification_decision_method: z.string().optional().nullable(),
  issuer_drawing_number: z.string().optional().nullable(),
  secondary_drawing_number: z.string().optional().nullable(),
  sheet_number: z.string().optional().nullable(),
  latest_revision: z.string().optional().nullable(),
  latest_revision_date: z.string().optional().nullable(),
  system: z.string().optional().nullable(),
  document_type: z.string().optional().nullable(),
  document_title: z.string().optional().nullable(),
  issuer_company_name: z.string().optional().nullable(),
  issuer_company_role: z.string().optional().nullable(),
  viewing_rotation: z.string().optional().nullable(),
  is_revision_controlled_drawing: z.string().optional().nullable(),
  design_facility: z.string().optional().nullable(),
  rich_text_summary: z.string().optional().nullable(),
})

export const SystemDocumentPageEntrySchema = z.looseObject({
  entry: z.looseObject({
    id: z.string(),
    type: z.literal(RolodexEntryType.SYSTEM_DOCUMENT_PAGE),
    data: SystemDocumentPageJSONSchema,
    tags: z.record(z.string(), z.union([z.string(), z.null()])).optional(),
    updated_at: z.string().optional(),
    last_updated_by: z.string().optional(),
  }),
  links: z.record(z.string(), z.unknown()).optional(),
})

export type SystemDocumentPageJSON = z.infer<
  typeof SystemDocumentPageJSONSchema
>
export type SystemDocumentPageEntry = z.infer<
  typeof SystemDocumentPageEntrySchema
>

export function parseSystemDocumentPageEntries(
  data: unknown
): SystemDocumentPageEntry[] {
  if (!Array.isArray(data)) return []

  const parsed: SystemDocumentPageEntry[] = []
  for (const item of data) {
    const result = SystemDocumentPageEntrySchema.safeParse(item)
    if (result.success) {
      parsed.push(result.data)
    }
  }
  return parsed
}
